/**
 * WB AI Chat Session Management
 * Handles session storage, URL parameters, and search query management.
 * Conversation restore is done in the chat interface via GET /conversations/:id + WebSocket.
 */
import { debugLog } from './utils';
export class ChatSessionManager {
    constructor() {
        this.SESSION_STORAGE_KEY = 'wb_ai_chat_conversation_id';
        this.LAST_SEARCH_QUERY_KEY = 'wb_ai_chat_last_search_query';
        this.currentConversationId = null;
    }
    getCurrentConversationId() {
        return this.currentConversationId;
    }
    setCurrentConversationId(id) {
        this.currentConversationId = id;
    }
    saveSession() {
        if (this.currentConversationId) {
            try {
                sessionStorage.setItem(this.SESSION_STORAGE_KEY, this.currentConversationId);
                debugLog('Chat session saved:', this.currentConversationId);
            }
            catch (error) {
                console.warn('Failed to save chat session:', error);
            }
        }
    }
    loadSession() {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const paramConversationId = urlParams.get('chat_session');
            if (paramConversationId) {
                this.currentConversationId = paramConversationId;
                try {
                    sessionStorage.setItem(this.SESSION_STORAGE_KEY, paramConversationId);
                    debugLog('Chat session loaded from URL parameter:', paramConversationId);
                }
                catch (error) {
                    console.warn('Failed to save chat session from URL parameter:', error);
                }
                return true;
            }
            const conversationId = sessionStorage.getItem(this.SESSION_STORAGE_KEY);
            if (conversationId) {
                this.currentConversationId = conversationId;
                debugLog('Chat session loaded:', conversationId);
                return true;
            }
            else {
                debugLog('No cached chat session found');
            }
        }
        catch (error) {
            console.warn('Failed to load chat session:', error);
        }
        return false;
    }
    clearSession() {
        try {
            const oldId = sessionStorage.getItem(this.SESSION_STORAGE_KEY);
            sessionStorage.removeItem(this.SESSION_STORAGE_KEY);
            sessionStorage.removeItem(this.LAST_SEARCH_QUERY_KEY);
            this.currentConversationId = null;
            debugLog('Chat session cleared:', oldId);
        }
        catch (error) {
            console.warn('Failed to clear chat session:', error);
        }
    }
    hasAlreadySentSearchQuery(query) {
        try {
            const lastSentQuery = sessionStorage.getItem(this.LAST_SEARCH_QUERY_KEY);
            return lastSentQuery === query;
        }
        catch (error) {
            console.warn('Failed to check last search query:', error);
            return false;
        }
    }
    saveSentSearchQuery(query) {
        try {
            sessionStorage.setItem(this.LAST_SEARCH_QUERY_KEY, query);
            debugLog('Saved sent search query:', query);
        }
        catch (error) {
            console.warn('Failed to save sent search query:', error);
        }
    }
    getSearchQueryFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get('s');
        // URLSearchParams has already decoded the value; decoding again throws on a literal "%".
        if (searchQuery && searchQuery.trim()) {
            return searchQuery.trim();
        }
        return null;
    }
}
